import React, { useState, useEffect } from "react";
import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { feature } from "topojson-client";

const INDIA_TOPO_JSON = "mapdata/india.topo.json";
const CLIENT_JSON = "mapdata/clients.json";
const CIRCLE_RADIUS = 3.5; // Radius for markers
function App() {
  const [geoData, setGeoData] = useState([]);
  const [markers, setMarkers] = useState([]);
  const [currentTooltipIndex, setCurrentTooltipIndex] = useState(null); // for auto tooltip
  const [manualHoverIndex, setManualHoverIndex] = useState(null);       // for manual hover

  useEffect(() => {
    fetch(INDIA_TOPO_JSON)
      .then((res) => res.json())
      .then((topology) => {
        const geoFeatures = feature(topology, topology.objects.india);
        setGeoData(geoFeatures);
      });
  }, []);

  useEffect(() => {
    fetch(CLIENT_JSON)
      .then((res) => res.json())
      .then((data) => setMarkers(data));
  }, []);

  // Automatically cycle tooltips one by one for 1 minute
  useEffect(() => {
    if (!markers.length) return;

    let index = 0;
    const interval = setInterval(() => {
      setCurrentTooltipIndex(index);
      setManualHoverIndex(null); // clear manual on auto trigger
      index++;
      if (index >= markers.length) {
        clearInterval(interval);
        setTimeout(() => setCurrentTooltipIndex(null), 2000);
      }
    }, 2000);

    return () => clearInterval(interval);
  }, [markers]);

  // Tooltip anchor: either manually hovered or current autoplay index
  const activeIndex = manualHoverIndex !== null ? manualHoverIndex : currentTooltipIndex;

  return (
    <div>
      <h2 style={{ textAlign: "center" }}>Our Presence</h2>

      <ComposableMap
        projection="geoMercator"
        projectionConfig={{ scale: 850, center: [82.8, 22.6] }}
        style={{ width: "100%", height: "auto" }}
      >
        <Geographies geography={geoData}>
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                style={{
                  default: { fill: "#D6D6DA", outline: "none" },
                  hover: { fill: "#444444", outline: "none" },
                  pressed: { fill: "#E42", outline: "none" }
                }}
              />
            ))
          }
        </Geographies>

        {markers.map(({ name, coordinates, image }, idx) => (
          <Marker key={name} coordinates={coordinates}>
            <circle
              r={CIRCLE_RADIUS}
              fill="#F37021"
              data-tooltip-id="tooltip"
              data-tooltip-content={name}
              data-marker-index={idx}
              style={{ cursor: "pointer" }}
              onMouseEnter={() => setManualHoverIndex(idx)}
              onMouseLeave={() => setManualHoverIndex(null)}
            />
          </Marker>
        ))}
      </ComposableMap>

      <ReactTooltip
        id="tooltip"
        anchorSelect={activeIndex !== null ? `circle[data-marker-index="${activeIndex}"]` : ""}
        isOpen={activeIndex !== null}
        style={{ backgroundColor:"white",
                          color:"black" }}
        render={({ activeAnchor }) => {
          if (!activeAnchor) return null;
          const idx = parseInt(activeAnchor.getAttribute("data-marker-index"));
          const marker = markers[idx];
          return (
            <div style={{ textAlign: "center",
                           }}>
              {/* <strong>{marker.name}</strong>
              <br /> */}
              <img
                src={marker.image}
                alt={marker.name}
                style={{ width: "100px", marginTop: "5px" }}
              />
            </div>
          );
        }}
      />
    </div>
  );
}

export default App;
